import React from 'react';
export function Footer() {
  return <footer className="bg-[#051009] py-12 px-4 text-center" data-id="element-100">
      <div className="max-w-4xl mx-auto" data-id="element-101">
        <div className="text-2xl font-bold text-[#CCFF00] mb-8 drop-shadow-[0_0_8px_rgba(204,255,0,0.3)]" data-id="element-102">
          🏉 RUGBY 360™
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-gray-300 mb-8 text-sm" data-id="element-103">
          <a href="#" className="hover:text-white transition-colors" data-id="element-104">
            📧 contacto@rugby360.com.ar
          </a>
          <span className="hidden md:inline" data-id="element-105">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-106">
            📲 @rugby360.ar
          </a>
          <span className="hidden md:inline" data-id="element-107">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-108">
            🌐 www.rugby360.com.ar
          </a>
        </div>

        <p className="text-gray-500 text-xs" data-id="element-109">
          © RUGBY 360™ 2025 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}